import React from 'react';
import { useHooks, breakpoints, Tab } from '@everlywell/leaves';

import ResourceDropdown from '../ResourceDropdown';
import * as S from './styles';

interface ResourceListFilterProps {
  onFilterSelect: (x: number) => void;
  filters: string[];
  initialActiveIndex: number;
}
export const ResourceListFilter: React.FC<ResourceListFilterProps> = ({
  onFilterSelect,
  filters,
  initialActiveIndex,
}: ResourceListFilterProps) => {
  const windowSize = useHooks.useWindowSize();
  const isMobile = windowSize?.width
    ? windowSize.width < breakpoints.forTabletHorizontalUp
    : false;
  const isBrowser = typeof window !== 'undefined';

  return (
    <div data-testid="resourceFilter">
      {isBrowser ? (
        isMobile ? (
          <ResourceDropdown
            items={filters}
            onItemSelect={onFilterSelect}
            activeIndex={initialActiveIndex}
            id="dropdownResourceFilter"
            label="View"
            name="dropdownResourceFilter"
          />
        ) : (
          <S.StyledTabMenu
            onItemSelect={onFilterSelect}
            initialActiveIndex={initialActiveIndex}
            ariaLabel="Resources Category Filter"
            ariaControls="ResourceList"
            id="tabResourceFilter"
          >
            {filters.map((item, i) => (
              <Tab key={i}>{item}</Tab>
            ))}
          </S.StyledTabMenu>
        )
      ) : (
        <></>
      )}
    </div>
  );
};

export default ResourceListFilter;
